import { z } from 'zod';

import { FEATURE } from '~/common/enums/feature.enum';
import { useTreatments } from '~/domains/common/hooks/useTreatments';

const disabledPaymentMethodsConfigSchema = z.object({
  web: z
    .object({
      deposit: z.record(z.boolean()).optional(),
      withdrawal: z.record(z.boolean()).optional(),
    })
    .optional(),
});

export const useWebDisabledPaymentMethods = (): { deposit: string[]; withdrawal: string[] } => {
  const { treatments } = useTreatments([FEATURE.DISABLED_PAYMENT_METHODS]);
  const treatment = treatments[FEATURE.DISABLED_PAYMENT_METHODS];

  if (!treatment || treatment.treatment === 'off') {
    return { deposit: [], withdrawal: [] };
  }

  const parsedConfig = disabledPaymentMethodsConfigSchema.safeParse(treatment.config);

  if (!parsedConfig.success) {
    return { deposit: [], withdrawal: [] };
  }

  const { deposit, withdrawal } = parsedConfig.data.web ?? {};

  return {
    deposit: Object.entries(deposit ?? {})
      .filter(([, disabled]) => disabled)
      .map(([name]) => name),
    withdrawal: Object.entries(withdrawal ?? {})
      .filter(([, disabled]) => disabled)
      .map(([name]) => name),
  };
};
